  (function () {
  // Runs on load and again whenever a new lab module appears: sibling swatches (Solid/Stripes/Polka)
  // swap the product section in place, and scripts inside swapped-in HTML never run.
  function init() {
    // Backdrops are moved to <body>; drop any whose module was swapped out
    Array.prototype.forEach.call(document.querySelectorAll('body > [data-lab-backdrop]'), function (b) {
      if (b.__labRoot && !document.contains(b.__labRoot)) {
        b.parentNode.removeChild(b);
        if (!document.querySelector('body > [data-lab-backdrop][data-open]')) document.body.classList.remove('ecoy-lab-locked');
      }
    });

    var roots = document.querySelectorAll('[data-lab-results]:not([data-lab-ready])');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-lab-ready', '');

      var openBtn  = root.querySelector('[data-lab-open]');
      var backdrop = root.querySelector('[data-lab-backdrop]');
      var modal    = root.querySelector('[data-lab-modal]');
      var closeBtn = root.querySelector('[data-lab-close]');
      var tabs     = Array.prototype.slice.call(root.querySelectorAll('[data-lab-tab]'));
      var panels   = Array.prototype.slice.call(root.querySelectorAll('[data-lab-panel]'));
      var moreBtn  = root.querySelector('[data-lab-more]');
      var extra    = root.querySelector('[data-lab-extra]');
      var lastFocus = null;

      if (!openBtn || !backdrop || !modal) return;

      // A fixed-position element is contained by any ancestor with transform,
      // filter, perspective or contain. Stiletto's product column has sticky
      // behaviour and app blocks sit nearby, so rather than hope, move the
      // backdrop to <body> where nothing can trap it.
      backdrop.__labRoot = root;
      if (backdrop.parentNode !== document.body) document.body.appendChild(backdrop);

      var FOCUSABLE = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

      function openModal() {
        lastFocus = document.activeElement;
        backdrop.removeAttribute('hidden');
        backdrop.setAttribute('data-open', '');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ecoy-lab-locked');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        backdrop.removeAttribute('data-open');
        backdrop.setAttribute('hidden', '');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ecoy-lab-locked');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function selectTab(name, focusIt) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-lab-tab') === name;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focusIt) t.focus();
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-lab-panel') === name) p.setAttribute('data-active', '');
          else p.removeAttribute('data-active');
        });
        var body = root.querySelector('.ecoy-lab__body');
        if (body) body.scrollTop = 0;
      }

      openBtn.addEventListener('click', openModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      backdrop.addEventListener('click', function (e) {
        if (e.target === backdrop) closeModal();
      });

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          selectTab(t.getAttribute('data-lab-tab'), false);
        });
      });

      var tabList = root.querySelector('[role="tablist"]');
      if (tabList) {
        tabList.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var names = tabs.map(function (t) { return t.getAttribute('data-lab-tab'); });
          var current = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
          if (current < 0) return;
          var step = e.key === 'ArrowRight' ? 1 : names.length - 1;
          selectTab(names[(current + step) % names.length], true);
          e.preventDefault();
        });
      }

      if (moreBtn && extra) {
        moreBtn.addEventListener('click', function () {
          var open = extra.hasAttribute('data-open');
          var label = moreBtn.querySelector('[data-lab-more-label]');
          if (open) {
            extra.removeAttribute('data-open');
            moreBtn.setAttribute('aria-expanded', 'false');
            if (label) label.textContent = 'Show all ' + (moreBtn.getAttribute('data-lab-total') || '') + ' substance groups';
          } else {
            extra.setAttribute('data-open', '');
            moreBtn.setAttribute('aria-expanded', 'true');
            if (label) label.textContent = 'Show less';
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (!document.contains(root) || !backdrop.hasAttribute('data-open')) return;
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE))
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      });
    });
  }

  init();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; init(); }, 50);
  }).observe(document.body, { childList: true, subtree: true });
  })();
